// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__2LIBX","Blue":"Status_Blue__1ioKV","Yellow":"Status_Yellow__26qaC","Orange":"Status_Orange__1J0dE","Green":"Status_Green__1ZEjt","Red":"Status_Red__3Yaf_"};